import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { useTranslate } from '@dreryk/react-common';

import { FormSectionHeader } from '../common/FormSectionHeader';
import { entitlementStatementsTranslationKeys } from '../translations';

import { EntitlementStatementsTable } from './table/EntitlementStatementsTable';

type EntitlementStatementsSectionProps = {
   readonly patientId: Patient['id'];
};

export const EntitlementStatementsSection = ({ patientId }: EntitlementStatementsSectionProps): JSX.Element => {
   const translate = useTranslate();
   return (
      <div>
         <FormSectionHeader>{translate(entitlementStatementsTranslationKeys.entitlementStatements)}</FormSectionHeader>
         <EntitlementStatementsTable patientId={patientId} />
      </div>
   );
};
